import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const promoBannerBlockSchema = Joi.object({
  type: Joi.string().valid('promoBannerBlock').required(),
  code: Joi.string().allow('', null),
  title: Joi.string().allow('', null),
  description: Joi.string().allow('', null),
  ctaText: Joi.string().allow('', null),
  ctaLink: Joi.string().allow('', null),
  image: mediaUrlSchema.allow(null),
  video: mediaUrlSchema.allow(null),
  imageAlt: Joi.string().allow('', null),
  labelType: Joi.string().valid('new', 'promotion', 'bestseller').allow(null),
  reversed: Joi.boolean().allow(null)
}).unknown(true);
export default promoBannerBlockSchema;